import { Directive, Injectable, Input, OnDestroy, OnInit } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LockScrollContextService {
  private stack = 0;

  pushContext() {
    return ++this.stack;
  }

  popContext() {
    return --this.stack;
  }

  public scrollPosition: number;
}

@Directive({ selector: '[lockScroll]' })
export class LockScrollDirective implements OnInit, OnDestroy {
  @Input('lockScroll')
  lock: boolean;

  ngOnInit() {
    if (this.lock) {
      const context = this.context.pushContext();
      if (context > 0) {
        this.lockScroll();
      }
    }
  }

  ngOnDestroy() {
    if (this.lock) {
      const context = this.context.popContext();
      if (context <= 0) {
        this.unlockScroll();
      }
    }
  }

  private lockScroll() {
    this.context.scrollPosition = document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.top = `${this.context.scrollPosition * -1}px`;
  }

  private unlockScroll() {
    document.body.removeAttribute('style');
    document.documentElement.scrollTop = this.context.scrollPosition;
  }

  constructor(private readonly context: LockScrollContextService) {}
}
